import { ISubscription, ISubscriptionUpdateModel } from "../models/Subscription";
import $api from "../http";

class SubscriptionServiceClass {
  async createSubscription(model: Omit<ISubscription, "id">) {
    return await $api.post<boolean>("api/subscriptions/create", model);
  }

  async getAllSubscriptions(searchValue: string | null) {
    return await $api.get<ISubscription[]>(
      `api/subscriptions/get-all?searchValue=${searchValue || ""}`
    );
  }

  async updateSubscription(id: string, model: ISubscriptionUpdateModel) {
    return $api.put<boolean>(`api/subscriptions/update/${id}`, model);
  }

  async deleteSubscription(id: string) {
    return await $api.delete<boolean>(`api/subscriptions/delete/${id}`);
  }
}

export const SubscriptionService = new SubscriptionServiceClass();
